jQuery.cookie = function(b, j, m) {
    if (typeof j != "undefined") {
        m = m || {}, j === null && (j = "", m.expires = -1);
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            typeof m.expires == "number" ? (f = new Date, f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1e3)) : f = m.expires, e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + m.path : "",
            g = m.domain ? "; domain=" + m.domain : "",
            a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else {
        var d = null;
        if (document.cookie && document.cookie != "")
            for (var k = document.cookie.split(";"), h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == b + "=") {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break
                }
            }
        return d
    }
}, Shopify.Products = function() {
    var config = {
            howManyToShow: 3,
            howManyToStoreInMemory: 4,
            wrapperId: "recently-viewed-products",
            sectionId: "recently-viewed-products-wrapper",
            templateId: "recently-viewed-product-template",
            onComplete: null
        },
        productHandleQueue = [],
        wrapper = null,
        template = null,
        section = null,
        shown = 0,
        cookie = {
            configuration: {
                expires: 90,
                path: "/",
                domain: window.location.hostname
            },
            name: "shopify_recently_viewed",
            write: function(recentlyViewed) {
                jQuery.cookie(this.name, recentlyViewed.join(" "), this.configuration)
            },
            read: function() {
                var recentlyViewed = [],
                    cookieValue = jQuery.cookie(this.name);
                return cookieValue !== null && (recentlyViewed = cookieValue.split(" ")), recentlyViewed
            },
            destroy: function() {
                jQuery.cookie(this.name, null, this.configuration)
            },
            remove: function(productHandle) {
                var recentlyViewed = this.read(),
                    position = jQuery.inArray(productHandle, recentlyViewed);
                position !== -1 && (recentlyViewed.splice(position, 1), this.write(recentlyViewed))
            }
        },
        finalize = function() {
            if (section.show(), config.onComplete) try {
                config.onComplete()
            } catch (error) {}
        },
        moveAlong = function() {
            productHandleQueue.length && shown < config.howManyToShow ? jQuery.ajax({
                dataType: "json",
                url: "/products/" + productHandleQueue[0] + ".js",
                cache: !1,
                success: function(product) {

jQuery.ajax({
            dataType: "json",
            url: "/products/" + productHandleQueue[0] + ".json",
            cache: !1,
            success: function(metafields) {
              
                product.metafields = metafields;
            console.log(product.metafields)
               // template.tmpl(product).appendTo(wrapper);
            }
        });
                  
                    template.tmpl(product).appendTo(wrapper), productHandleQueue.shift(), shown++, moveAlong()
                },
                error: function() {
                    cookie.remove(productHandleQueue[0]), productHandleQueue.shift(), moveAlong()
                }
            }) : finalize()
        };
    return {
     
        resizeImage: function(src, size) {
            if (size == null) return src;
            if (size == "master") return src.replace(/http(s)?:/, "");
            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
            if (match != null) {
                var prefix = src.split(match[0]),
                    suffix = match[0];
                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else return null
        },
        showRecentlyViewed: function(params) {
            var params = params || {};
            jQuery.extend(config, params), productHandleQueue = cookie.read(), template = jQuery("#" + config.templateId), wrapper = jQuery("#" + config.wrapperId), section = jQuery("#" + config.sectionId), config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow), config.howManyToShow && template.length && wrapper.length && moveAlong()
        },
        getConfig: function() {
            return config
        },
        clearList: function() {
            cookie.destroy()
        },
        recordRecentlyViewed: function(params) {
            var params = params || {};
            jQuery.extend(config, params);
            var recentlyViewed = cookie.read();
            if (window.location.pathname.indexOf("/products/") !== -1) {
                var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1],
                    position = jQuery.inArray(productHandle, recentlyViewed);
                position === -1 ? (recentlyViewed.unshift(productHandle), recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory)) : (recentlyViewed.splice(position, 1), recentlyViewed.unshift(productHandle)), cookie.write(recentlyViewed)
            }
       
        }
    }
}();